'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _lodash = _interopRequireDefault(require("lodash.assign"));

var _sfpReactModal = _interopRequireDefault(require("sfp-react-modal"));

var _translate = _interopRequireDefault(require("../translate"));

var _index = _interopRequireDefault(require("../location-map/index"));

var Actions = _interopRequireWildcard(require("./actions"));

var _loader = _interopRequireDefault(require("../loader"));

var _calcMapFocus = _interopRequireDefault(require("../../lib/calc-map-focus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var HofsearchMap = /*#__PURE__*/function (_React$Component) {
  _inherits(HofsearchMap, _React$Component);

  function HofsearchMap(props) {
    var _this;

    _classCallCheck(this, HofsearchMap);

    _this = _possibleConstructorReturn(this, (HofsearchMap.__proto__ || Object.getPrototypeOf(HofsearchMap)).call(this, props));
    _this.state = {
      loading: false,
      modalOpen: props.open,
      calculatedZoom: props.zoom,
      calculatedCenter: {
        lat: props.coordinates.lat,
        lng: props.coordinates.lon
      }
    };
    _this.goToFarm = _this.goToFarm.bind(_assertThisInitialized(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
    _this.toggleHistory = _this.toggleHistory.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(HofsearchMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.showMap) {
        this.openModal(false);
        return;
      }

      if (!this.props.iframe.isIframe) return;

      if (this.props.iframe.showMap) {
        this.openModal(false);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.consentStates['google-maps'] !== this.props.consentStates['google-maps']) {
        return true;
      }

      if (prevProps.locations.length !== this.props.locations.length) {
        var mapFocus = (0, _calcMapFocus.default)(this.props.locations, this.props.zoom, {
          lat: this.props.coordinates.lat,
          lng: this.props.coordinates.lon
        });
        this.setState(function (prev) {
          prev.calculatedZoom = mapFocus.zoom;
          prev.calculatedCenter = mapFocus.center;
          return prev;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          t = _this$props.t,
          i18n = _this$props.i18n;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, this.props.opener === 'button' && (this.props.consentStates['google-maps'] || this.props.iframe.isIframe) && /*#__PURE__*/_react.default.createElement("button", {
        onClick: function onClick() {
          _this2.openModal(true);
        },
        className: "button button--farm-search-map map-wrapper"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "map-title"
      })), this.props.opener === 'link' && /*#__PURE__*/_react.default.createElement("a", {
        className: 'no-farms-map-link',
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.openModal(true);
        }
      }, this.props.openerTitle), /*#__PURE__*/_react.default.createElement(_sfpReactModal.default, {
        closeHandler: function closeHandler() {
          return _this2.closeModal();
        },
        backgroundClickClose: !this.state.loading,
        escClose: !this.state.loading,
        isOpen: this.state.modalOpen,
        id: 'map'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-hofsearch-map'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'map-menu-wrapper'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'map-menu-item map-menu-item--title'
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "map-card-title"
      }, t('Karte')), /*#__PURE__*/_react.default.createElement("a", {
        className: 'cross',
        onClick: this.closeModal
      }))), this.state.modalOpen && /*#__PURE__*/_react.default.createElement(_index.default, {
        draggable: true,
        latitude: this.props.coordinates.lat,
        longitude: this.props.coordinates.lon,
        zoom: this.props.zoom,
        calculatedCenter: this.state.calculatedCenter,
        calculatedZoom: this.state.calculatedZoom,
        loadingElement: /*#__PURE__*/_react.default.createElement(_loader.default, null),
        containerElement: /*#__PURE__*/_react.default.createElement("div", {
          className: 'map-container comp-location-map'
        }),
        mapElement: /*#__PURE__*/_react.default.createElement("div", {
          className: "map-element"
        }),
        locations: this.props.locations,
        outlets: this.props.outlets,
        outletsAll: this.props.outletsAll,
        i18n: i18n,
        t: t,
        goToFarm: this.goToFarm,
        activeFarmIdOnMap: this.props.activeFarmIdOnMap,
        theme: this.props.theme
      }))));
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      var _this3 = this;

      this.toggleHistory(true, true);
      this.setState(function (prev) {
        prev.modalOpen = false;
        return prev;
      }, function () {
        _this3.props.dispatch(Actions.setClosed());
      });
    }
  }, {
    key: "openModal",
    value: function openModal(historyChange) {
      this.toggleHistory(historyChange, false);
      this.setState(function (prev) {
        prev.modalOpen = true;
        return prev;
      });
    }
  }, {
    key: "toggleHistory",
    value: function toggleHistory(historyChange, close) {
      if (!historyChange) return;
      var url = new URL(window.location.href);

      if (close) {
        url.pathname = "/".concat(this.props.i18n.language);
        url.searchParams.delete('extSearch');
        url.searchParams.delete('extSearch.query.q');
        window.history.pushState({}, '', url);
        return;
      }

      url.pathname = "/".concat(this.props.i18n.language, "/map");

      if (this.props.search) {
        url.searchParams.set('extSearch', 1);
        url.searchParams.set('extSearch.query.q', this.props.search);
      }

      window.history.pushState({}, '', url);
    }
    /**
     *
     * @param ctrlKey
     * @param id
     * @param userSettings
     * @param anchor
     */

  }, {
    key: "goToFarm",
    value: function goToFarm(ctrlKey, id, userSettings, anchor) {
      var _this4 = this;

      this.setState(function (prev) {
        prev.modalOpen = ctrlKey;
      }, function () {
        var _this4$props = _this4.props,
            history = _this4$props.history,
            i18n = _this4$props.i18n;

        _this4.props.dispatch(Actions.setCoordinates(userSettings.lat, userSettings.lon));

        _this4.props.dispatch(Actions.setZoom(userSettings.zoom));

        _this4.props.dispatch(Actions.setOpen());

        _this4.props.dispatch(Actions.setActiveFarmId(parseInt(id)));

        var url = "/".concat(i18n.language, "/farm/farm-").concat(id).concat(anchor);

        if (ctrlKey) {
          window.open(url, '_blank');
          return;
        }

        history.push(url);
      });
    }
  }]);

  return HofsearchMap;
}(_react.default.Component);
/**
 * Maps state from redux to props of the component. use this only for container-component.
 *
 * @param state
 * @returns {{languages: Array|*|string[]}}
 */


var mapStateToProps = function mapStateToProps(state) {
  (0, _lodash.default)(state.map, {
    iframe: state.iframe
  }, {
    shared: state.shared
  }, {
    search: state.farm.search,
    loading: state.farm.loading
  }, {
    consentStates: state.consentStates
  }); // assign does  a shallow copy. {...state} somehow not available on the server (??)

  return JSON.parse(JSON.stringify(state)).map;
};

HofsearchMap.defaultProps = {
  opener: 'button',
  openerTitle: '',
  showMap: false
};
HofsearchMap.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  locations: _propTypes.default.array,
  outlets: _propTypes.default.array,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string
    })
  }),
  iframe: _propTypes.default.shape({
    isIframe: _propTypes.default.bool,
    showMap: _propTypes.default.string
  }),
  open: _propTypes.default.bool,
  zoom: _propTypes.default.number,
  coordinates: _propTypes.default.shape({
    lon: _propTypes.default.number,
    lat: _propTypes.default.number
  }),
  dispatch: _propTypes.default.func.isRequired,
  activeFarmIdOnMap: _propTypes.default.number,
  opener: _propTypes.default.oneOf(['button', 'link']),
  openerTitle: _propTypes.default.string,
  theme: _propTypes.default.string,
  outletsAll: _propTypes.default.array,
  showMap: _propTypes.default.bool,
  search: _propTypes.default.string,
  consentStates: _propTypes.default.shape()
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _translate.default)(HofsearchMap));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/hofsearch-map/index.js
// module id = 670
// module chunks = 0